import type { DeviceMutState } from "@app/core";

/** Which sync engine an acknowledgement (or a self-acknowledged write) is for. */
export type SyncDestination = "server" | "google";

export function ackedColumn(dest: SyncDestination): "server_acked_mut" | "google_acked_mut" {
  return dest === "server" ? "server_acked_mut" : "google_acked_mut";
}

/**
 * The clamped next ack value for a row, or null when nothing would change.
 * `acked = max(acked, min(upTo, mut))`: never backwards, and never past the
 * row's CURRENT `mut` — an edit that landed after the upload's read keeps the
 * row dirty rather than being silently swallowed by the acknowledgement.
 */
export function clampAck(row: DeviceMutState, dest: SyncDestination, upTo: number): number | null {
  const acked = row[ackedColumn(dest)] ?? 0;
  const next = Math.max(acked, Math.min(upTo, row.mut ?? 0));
  return next === acked ? null : next;
}
